<template>
  <div id="header" class="wrap">
    <div class="logo">
      <img src="@/assets/images/logo2.png" alt="" />
    </div>
    <div
      v-for="(item, index) in btnList"
      :key="index"
      @click="handleClick(item.component)"
      :class="[
        item.component === 'incomingOrder' && getCount?.incoming_order_count > 0 ? 'remind-yellow' : '',
        item.component === 'outsideOrder' && getCount?.outside_order_count > 0 ? 'remind-yellow' : '',
      ]"
      style="cursor: pointer"
    >
      <i :class="`bi bi-${item.icon}`"></i>
      {{ item.name }}({{ getCount ? getCount[item.count] : 0 }})
    </div>
    <div class="d-flex" style="height: 40px">
      <cus-button
        text="訂單"
        color="darkBlue"
        :width="50"
        textClass="button-text"
        class="header-btn b-left"
        @click="openOrderDialog('manageOrder')"
      ></cus-button>
      <div class="manage-button-wrap">
        <i
          v-if="getCount?.notification_unread_count > 0 || getSoftwareStatus === 3"
          class="bi bi-exclamation-circle-fill notice-icon"
        ></i>
        <cus-button
          text="管理"
          color="darkBlue"
          textClass="button-text"
          class="header-btn b-right"
          @click="openOrderDialog('manageAction')"
        ></cus-button>
      </div>
    </div>
    <!-- 叮咚聲 -->
    <audio id="ding" :src="path + 'sound/ding.mp3'" preload="auto"></audio>
    <!-- 各式彈窗 -->
    <component :is="orderDialogTemplate"></component>
  </div>
</template>
<script>
import { reactive, defineAsyncComponent, watch, nextTick } from 'vue';
import { useOrderDialog } from '@/utils/manageOrderDialog';
import { useGetters, useActions } from '@/utils/mapStore';
export default {
  name: 'Header',
  components: {
    PendingOrder: defineAsyncComponent(() => import('@/components/orderDialog/PendingOrder.vue')),
    IncomingOrder: defineAsyncComponent(() => import('@/components/orderDialog/IncomingOrder.vue')),
    OutsideOrder: defineAsyncComponent(() => import('@/components/orderDialog/OutsideOrder.vue')),
    ManageOrder: defineAsyncComponent(() => import('@/components/orderDialog/ManageOrder.vue')),
    Accounting: defineAsyncComponent(() => import('@/components/orderDialog/Accounting.vue')),
    ManageAction: defineAsyncComponent(() => import('@/components/orderDialog/ManageAction.vue')),
    Shift: defineAsyncComponent(() => import('@/components/orderDialog/Shift.vue')),
    Notification: defineAsyncComponent(() => import('@/components/orderDialog/Notification.vue')),
  },
  setup() {
    const btnList = reactive([
      { name: '掛單', icon: 'exclamation-square', component: 'pendingOrder', count: 'pending_order_count' },
      { name: '內部平台', icon: 'stop-circle', component: 'incomingOrder', count: 'incoming_order_count' },
      { name: '外部平台', icon: 'app-indicator', component: 'outsideOrder', count: 'outside_order_count' },
    ]);
    //取得軟體更新狀態
    const getSoftwareStatus = useGetters('upgrade', ['getSoftwareStatus']);
    //打開彈窗
    const { orderDialogTemplate, orderDialogVisible, openOrderDialog } = useOrderDialog();
    const handleClick = (component) => {
      openOrderDialog(component);
    };
    //管理選擇日結或交班
    const handleManageAction = (val) => {
      openOrderDialog(val);
    };
    //監聽彈窗關閉打echo
    const getCount = useGetters('system', ['getCount']);
    const getEcho = useActions('system', ['getEcho']);
    getEcho();
    watch(orderDialogVisible, () => {
      if (!orderDialogVisible.value) getEcho();
    });
    //監聽是否要自動彈出交班清帳彈窗
    const getShowShift = useGetters('accounting', ['getShowShift']);
    watch(getShowShift, () => {
      if (getShowShift.value) openOrderDialog('shift');
    });
    //監聽是否有內部訂單進單
    const playAudio = async () => {
      await nextTick();
      const dingSound = document.querySelector('#ding');
      dingSound.play();
    };
    watch(
      () => [getCount.value?.incoming_order_count, getCount.value?.outside_order_count],
      () => {
        if (getCount.value?.incoming_order_count > 0 || getCount.value?.outside_order_count > 0) playAudio();
      }
    );
    return {
      btnList,
      getSoftwareStatus,
      orderDialogTemplate,
      openOrderDialog,
      handleClick,
      handleManageAction,
      getCount,
    };
  },
  data() {
    return {
      path: process.env.VUE_APP_URL_PATH,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  @include flex-between-center;
  color: #fff;
  font-size: 2rem;
  padding: 0 3px;
  .logo {
    width: 160px;
    @include flex-center-center;
    img {
      width: 70%;
    }
  }
  .manage-button-wrap {
    display: flex;
    position: relative;
    .notice-icon {
      position: absolute;
      color: rgb(255, 62, 62);
      left: 0;
      animation: jump 1s linear infinite;
    }
  }
  .header-btn {
    min-height: auto;
    :deep(.button-text) {
      font-size: 2rem;
    }
  }

  .remind-yellow {
    color: $color-yellow;
    animation: blinker 0.4s linear infinite alternate;
  }

  @keyframes blinker {
    0% {
      color: #fff;
    }
    50% {
      color: #fff;
    }
    75% {
      color: $color-lightYellow;
    }
    100% {
      color: $color-lightYellow;
    }
  }
  @keyframes jump {
    0% {
      top: -5px;
    }
    20% {
      top: -10px;
    }
    30% {
      top: -5px;
    }
    50% {
      top: -10px;
    }
    60% {
      top: -5px;
    }
    100% {
      top: -5px;
    }
  }
}
</style>
